export default "__VITE_ASSET__cFITIYxB__"